import crud from './crud'
import locations from './locations'
import concepts from './concepts'
import users from './users'
import groups from './groups'

export default {
    namespaced: true,
    state: {
        ...crud.state,
        ...locations.state,
        ...concepts.state,
        ...users.state,
        ...groups.state
    },
    mutations: {
        ...crud.mutations,
        ...locations.mutations,
        ...concepts.mutations,
        ...users.mutations,
        ...groups.mutations,
    },
    actions: {
        ...crud.actions,
        ...locations.actions,
        ...concepts.actions,
        ...users.actions,
        ...groups.actions,
    }
}